import { getToken } from "./authHelper";
import {
  getChatSuggestionsFromPayload,
  normalizeChatSuggestions,
} from "./chatSuggestionUtilities";

export const fetchDocumentIdsWithDataSource = async (
  selectedDocumentType,
  setDocumentIds
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  var requestBody = null;
  try {
    const data_source = selectedDocumentType.value.toUpperCase();

    requestBody = {
      for_type: data_source,
    };

    const response = await fetch(
      `${apiUrl}/document:filter?orderType=DESC&orderBy=publication_timestamp&offset=0&limit=100000&getCount=false`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
          accept: "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    const data = await response.json();
    const document_ids = data.results.records.map((x) => {
      return {
        doc_id: x.id,
        time_stamp: x.publication_timestamp,
        category_theme: x.category_theme,
        public_data_source_url: x.public_data_source_url,
        document_name: x.document_name,
        impact_georegions_applicable: x.impact_georegions_applicable,
        data_source: x.data_source,
        document_tags: x.document_tags,
        for_type: x.for_type,
      };
    });
    setDocumentIds(document_ids);
  } catch (error) {
    console.error("Error in fetching Document Ids:", error);
  } finally {
  }
};

export const retriveRelevantImages = async (
  pageNumbers,
  documentIds,
  setImageUrls
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const document_id = documentIds ? documentIds[0]["doc_id"] : "";
    const page_number_list = pageNumbers
      ? pageNumbers.map((x) => x.toString())
      : [];

    const response = await fetch(`${apiUrl}/conversation/retrive_image_urls`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ page_number_list, document_id }),
    });
    const data = await response.json();

    setImageUrls(data);
  } catch (error) {}
};

export const retrivePdfUrl = async (documentIds, setPdfUrl) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const document_id = documentIds ? documentIds[0]["doc_id"] : "";

    const response = await fetch(`${apiUrl}/conversation/retrive_pdf_url`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ document_id }),
    });
    const data = await response.json();

    setPdfUrl(data["pdf_url"]);
  } catch (error) {}
};

export const getCompanyNames = async (country_name, setCompanyNames) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const requestBody = {
      country_name: country_name,
    };
    const response = await fetch(
      `${apiUrl}/conversation/retrive_company_names?country_name=${country_name}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();
    setCompanyNames(data.company_names);
  } catch (error) {
    console.error("Error fetching company names:", error);
  }
};

// utilities/DocAssistantUtilities.js

export function filterDocuments(docs, filters) {
  const { country, year, data_source, category_theme } = filters;

  return docs.filter((doc) => {
    const matchesCountry =
      Array.isArray(doc.impact_georegions_applicable) &&
      country &&
      doc.impact_georegions_applicable.includes(country);

    const matchesYear =
      Array.isArray(doc.document_tags) &&
      year != null &&
      doc.document_tags.includes(String(year));

    const matchesDataSource = !data_source || doc.data_source === data_source;

    const matchesCategoryTheme =
      !category_theme || doc.category_theme === category_theme;

    return (
      matchesCountry && matchesYear && matchesDataSource && matchesCategoryTheme
    );
  });
}

export const fetchChatSuggestions = async (
  documentId,
  setChatSuggestions,
  origin,
  extra_info,
  extra_suggestions
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const documentIds = documentId ? documentId.map((x) => x.doc_id) : null;
    const request_body = {
      document_ids: documentIds,
      origin,
      extra_info,
    };
    const response = await fetch(`${apiUrl}/conversation/get_suggestions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(request_body),
    });
    const data = await response.json();
    const suggestions = getChatSuggestionsFromPayload(data);
    if (suggestions.length > 0) {
      setChatSuggestions([
        ...normalizeChatSuggestions(extra_suggestions),
        ...suggestions,
      ]);
    }
  } catch (error) {
    console.error("Error fetching suggestions:", error);
  }
};


export const fetchFollowUpSuggestions = async (
  query,
  answer,
  setDynamicSuggestions,
  origin,
  extra_info
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const request_body = {
      query,
      answer,
      origin,
      extra_info,
    };
    const response = await fetch(`${apiUrl}/conversation/get_followup_suggestions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(request_body),
    });
    const data = await response.json();
    const suggestions = getChatSuggestionsFromPayload(data);
    if (suggestions.length > 0) {
      setDynamicSuggestions(suggestions);
    }
  } catch (error) {
    console.error("Error fetching suggestions:", error);
  }
};
